"use client";

import { ThemeProvider, createTheme } from "@mui/material";
import { green, grey, orange, red, teal } from "@mui/material/colors";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SessionProvider } from "next-auth/react";
import { Roboto_Flex, Roboto_Mono } from "next/font/google";

const roboto = Roboto_Flex({subsets: ['latin']})
const robotoMono = Roboto_Mono({subsets: ['latin']})

const theme = createTheme({
    typography: {
        fontFamily: roboto.style.fontFamily,
        mono: {
            fontFamily: robotoMono.style.fontFamily
        }
    },
    palette: {
        mode: "dark",
        primary: {
            main: teal[500],
        },
        secondary: {
            main: orange[500],

        },
        neutral: {
            main: grey[700],
        },
        error: {
            main: red[400],
        },
        success: {
            main: green[700],
        }
    },
    components: {
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
            styleOverrides: {
                root: {
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: "none"
                }
            }
        }
    },
})

export const AuthProvider = ({children}) => {
    return (
        <SessionProvider>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                        {children}
                </LocalizationProvider>
            </ThemeProvider>
        </SessionProvider>
    )
}